import { Button } from '@/components/ui/button';

import type { StepProps } from './step-props';

const PERKS = [
  ['Weekly Direct Deposit and Instant Pay.', 'Get paid quicker.'],
  ['24/7 Service/Support.', 'Our team is always just a phone call away.'],
  [
    'MAS Rewards Me Program.',
    'Earn prizes ranging from trips to technology to gift cards and everything in between.',
  ],
  ['401K Program.', 'Work full time for 1 year, and get a MAS 401(k) plan with company match.'],
] as const;

export function WelcomeStep({ record, onNext }: StepProps) {
  return (
    <div className="stack">
      <p className="eyebrow">Welcome, {record.firstName}</p>
      <h1>Complete your profile in just a few minutes</h1>
      <hr className="divider" />
      <p>
        <strong>MAS gives you more, like:</strong>
      </p>
      <ul className="perks">
        {PERKS.map(([lead, tail]) => (
          <li key={lead}>
            <strong>{lead}</strong> {tail}
          </li>
        ))}
      </ul>
      <Button
        onClick={() => {
          onNext({ kind: 'step', step: 'work_type' });
        }}
      >
        Complete your profile
      </Button>
    </div>
  );
}
